<section class="pov-card" *ngIf="hasAnyAction">
  <h2 class="pov-card__title">Approval</h2>

  <div class="poaa-actions">

    <!-- Re submit for approval -->
    <button
      *ngIf="canResubmit"
      class="poaa-btn poaa-btn--primary"
      (click)="resubmitForApproval.emit()"
    >
      Re submit for approval
    </button>

    <!-- Retry settlement -->
    <button
      *ngIf="canRetrySettlement"
      class="poaa-btn poaa-btn--primary"
      (click)="retrySettlement.emit()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M19.1244 10.1521C18.5444 10.0821 18.0244 10.5121 17.9944 11.0921C17.8944 13.0121 17.2344 14.8821 15.6744 16.0221C8.51443 21.2521 0.614433 15.2321 2.21443 8.15205C2.79443 5.57205 4.71443 3.40205 7.20443 2.50205C10.6644 1.25205 14.2044 2.42205 16.2744 5.00205H13.0344C12.4844 5.00205 12.0344 5.45205 12.0344 6.00205C12.0344 6.55205 12.4844 7.00205 13.0344 7.00205H18.0544C18.6044 7.00205 19.0544 6.55205 19.0544 6.00205V1.00205C19.0544 0.452051 18.6044 0.00205092 18.0544 0.00205092C17.5044 0.00205092 17.0544 0.452051 17.0544 1.00205V2.88205C14.5144 0.382051 10.7344 -0.697949 6.97443 0.472051C3.21443 1.64205 0.644433 4.80205 0.104433 8.54205C-0.775567 14.7021 4.02443 20.0021 10.0344 20.0021C15.0744 20.0021 19.3544 16.2521 19.9944 11.2721C20.0644 10.7221 19.6744 10.2221 19.1244 10.1521Z" fill="white"/>
      </svg>
      Retry settlement
    </button>

    <!-- Retry Trato -->
    <button
      *ngIf="canRetryTrato"
      class="poaa-btn poaa-btn--primary"
      (click)="retryTrato.emit()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M19.1244 10.1521C18.5444 10.0821 18.0244 10.5121 17.9944 11.0921C17.8944 13.0121 17.2344 14.8821 15.6744 16.0221C8.51443 21.2521 0.614433 15.2321 2.21443 8.15205C2.79443 5.57205 4.71443 3.40205 7.20443 2.50205C10.6644 1.25205 14.2044 2.42205 16.2744 5.00205H13.0344C12.4844 5.00205 12.0344 5.45205 12.0344 6.00205C12.0344 6.55205 12.4844 7.00205 13.0344 7.00205H18.0544C18.6044 7.00205 19.0544 6.55205 19.0544 6.00205V1.00205C19.0544 0.452051 18.6044 0.00205092 18.0544 0.00205092C17.5044 0.00205092 17.0544 0.452051 17.0544 1.00205V2.88205C14.5144 0.382051 10.7344 -0.697949 6.97443 0.472051C3.21443 1.64205 0.644433 4.80205 0.104433 8.54205C-0.775567 14.7021 4.02443 20.0021 10.0344 20.0021C15.0744 20.0021 19.3544 16.2521 19.9944 11.2721C20.0644 10.7221 19.6744 10.2221 19.1244 10.1521Z" fill="white"/>
      </svg>
      Retry Trato
    </button>

    <!-- Approve Purchase Order -->
    <button
      *ngIf="canApprove"
      class="poaa-btn poaa-btn--primary"
      [disabled]="isApproveDisabled"
      [appCustomTooltip]="approveTooltipText"
      [showToolTip]="showApproveTooltip"
      tooltipPosition="top"
      (click)="approvePurchaseOrder.emit()"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M9.60001 19.27C9.08001 19.27 8.57001 19.06 8.19001 18.68C8.14001 18.63 8.09001 18.57 8.04001 18.51L3.54001 14.08C2.81001 13.3 2.82001 12.06 3.58001 11.29C4.36001 10.51 5.63001 10.51 6.41001 11.29L9.60001 14.44L18.46 5.59C19.24 4.81 20.51 4.81 21.29 5.59C21.67 5.97 21.88 6.47 21.88 7C21.88 7.53 21.67 8.04 21.29 8.41L11.15 18.55C11.14 18.57 11.09 18.62 11.04 18.68C10.69 19.03 10.23 19.24 9.74001 19.26C9.69001 19.26 9.64001 19.27 9.60001 19.27Z" fill="currentColor"/>
      </svg>
      Approve Purchase Order
    </button>

    <!-- Return to KAM -->
    <button
      *ngIf="canReturnToKam"
      class="poaa-btn poaa-btn--danger"
      (click)="returnToKam.emit()"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M17.566 8.65742C17.852 8.3558 18 7.95016 18 7.55493C18 7.1597 17.8619 6.76446 17.5758 6.45244C16.9938 5.84919 16.0567 5.84919 15.4846 6.45244L12 10.1162C11.9951 10.1161 11.9902 10.1161 11.9852 10.1162L8.52034 6.45244C7.93835 5.84919 7.00123 5.84919 6.4291 6.45244C5.85697 7.06609 5.85697 8.05417 6.4291 8.65742L9.59827 11.999L6.43403 15.3426C6.14797 15.6442 6 16.0498 6 16.4451C6 16.8403 6.1381 17.2355 6.42417 17.5476C7.00617 18.1508 7.94328 18.1508 8.51541 17.5476L12 13.8838C12.0049 13.8839 12.0098 13.8839 12.0148 13.8838L15.4797 17.5476C16.0617 18.1508 16.9988 18.1508 17.5709 17.5476C18.143 16.9339 18.143 15.9458 17.5709 15.3426L14.4017 12.001L17.566 8.65742Z" fill="currentColor"/>
      </svg>
      Return to KAM
    </button>

  </div>
</section>
